import useOnLifecycleChanged from '@hooks/native/useOnLifecycleChanged';
import { useFlow } from '@stackflow/react';

const MAX_LEAVE_TIME = 3600;

function useLifeCycleReIssue() {
    const { replace } = useFlow();

    useOnLifecycleChanged({
        callbackFn: async (leaveTime?: number) => {
            if (leaveTime !== undefined) {
                if (leaveTime >= MAX_LEAVE_TIME) {
                    replace('MainActivity', {});
                }
            }
        },
    });
}

export default useLifeCycleReIssue;
